import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BlogDetailImg from "../assets/blog-detail.webp";

const BlogDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const post = location.state?.post;

  // If no post data is passed, use default content
  const blogData = post || {
    title: "The Future of Technology: Innovation Shaping Our World",
    category: "Featured Story",
    views: "12.5 M Views",
    image: BlogDetailImg,
    content:
      "Technology is evolving at an unprecedented pace, reshaping industries and redefining the way we live and work. From artificial intelligence to quantum computing, the innovations of today are laying the foundation for a future beyond imagination.",
    additionalContent:
      "In this blog, we explore some of the most promising technological advancements that are set to transform our world.",
  };

  const sections = [
    {
      title: "Artificial Intelligence (AI) and Machine Learning",
      description:
        "AI and machine learning are at the forefront of technological evolution. From smart assistants like Siri and Alexa to AI-driven healthcare diagnostics, these technologies are making systems more efficient and intelligent. In the future, AI is expected to revolutionize industries such as finance, education, and entertainment, offering highly personalized and predictive experiences.",
    },
    {
      title: "Quantum Computing",
      description:
        "Quantum computing promises to solve complex problems at speeds unimaginable with classical computers. Companies like Google, IBM, and Microsoft are making significant progress in this field. Quantum computers will have the potential to revolutionize drug discovery, cryptography, and data security, making computations more efficient and secure.",
    },
    {
      title: "5G and Beyond",
      description:
        "The rollout of 5G networks is set to enhance connectivity, enabling faster internet speeds and lower latency. This will pave the way for advancements in autonomous vehicles, IoT (Internet of Things), and smart cities. Beyond 5G, research into 6G technology aims to provide even more seamless and immersive digital experiences.",
    },
    {
      title: "Blockchain and Decentralized Systems",
      description:
        "Blockchain technology is no longer just about cryptocurrencies like Bitcoin and Ethereum. It is being integrated into supply chains, financial services, and even voting systems to enhance security and transparency. The rise of decentralized finance (DeFi) and smart contracts is revolutionizing traditional banking and investment practices.",
      highlighted: true,
    },
    {
      title: "Biotechnology and Genetic Engineering",
      description:
        "Advancements in biotechnology are opening new possibilities in medicine and agriculture. CRISPR gene-editing technology allows for precise modifications in DNA, which could lead to breakthroughs in curing genetic disorders and creating disease-resistant crops. The fusion of biology and technology will continue to shape the future of healthcare and food production.",
    },
  ];

  return (
    <div className="text-white pt-20 md:pt-32 pb-16">
      <div className="container mx-auto px-4">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 flex items-center text-blue-400 hover:text-blue-300 transition-colors"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="mr-2"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Posts
        </button>

        <div className="flex flex-col md:flex-row items-center gap-8">
          <div className="w-full md:w-1/2">
            <h4 className="text-gray-400 uppercase text-sm mb-2">
              {blogData.category}
            </h4>
            <h1 className="text-3xl sm:text-4xl font-bold mb-4">
              {blogData.title}
            </h1>
            <p className="text-gray-300 mb-6">{blogData.content}</p>
            <p className="text-gray-300 mb-6">{blogData.additionalContent}</p>
          </div>
          <div className="w-full md:w-1/3 mx-auto block">
            <img
              src={blogData.image}
              alt={blogData.title}
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
        </div>

        <div className="mt-16">
          <ul className="space-y-10">
            {sections.map((item, index) => (
              <li key={index}>
                <h2 className="text-xl md:text-2xl font-bold mb-4 flex items-baseline">
                  <span className="text-white mr-2">{index + 1}.</span>
                  <span className="text-white">{item.title}</span>
                </h2>
                <p className="text-gray-300 leading-relaxed pl-0 md:pl-7">
                  {item.description}
                </p>
              </li>
            ))}
          </ul>
          <div className="flex items-center justify-between mt-8 border-t border-gray-700 pt-4">
            <div className="flex items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-gray-400 mr-2"
              >
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
              <span className="text-gray-400">{blogData.views}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
